module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By " + _vm._s(_vm.investigators))]), _vm._v(" "), (_vm.trials == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no trials for the " + _vm._s(_vm.investigators) + " investigator.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-content-space-between": "",
      "mt-4": "",
      "mb-0": "",
      "ml-0": "",
      "mr-0": ""
    }
  }, _vm._l((_vm.trials), function(item, index) {
    return _c('v-card', {
      key: item.trialId,
      staticClass: "info",
      attrs: {
        "to": '/trials/' + item.trialId
      }
    }, [_c('v-list', {
      staticClass: "listItems"
    }, [_c('v-list-tile', {
      staticClass: "pl-2",
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [_c('span', {
      staticClass: "status"
    }, [_c('span', {
      class: _vm.enrollment(index).enrollmentName
    }), _c('br')])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(item.trialName) + "\n                ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v(_vm._s(_vm.enrollment(index).enrollmentName))]), _c('span', [_vm._v(" - " + _vm._s(_vm.locations(index).locationName))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "icon": "",
        "right": "",
        "ripple": "",
        "to": '/trials/' + item.trialId
      }
    }, [_c('right-icon', {
      staticClass: "icon",
      attrs: {
        "small": "",
        "color": item.active ? 'primary' : 'grey'
      }
    })], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile-action', {}, [_c('v-btn', {
      attrs: {
        "light": "",
        "icon": "",
        "right": "",
        "flat": "",
        "to": '/trials/' + item.trialId + '/edit'
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-2",
      attrs: {
        "small": "",
        "light": ""
      }
    }, [_vm._v("edit")])], 1)], 1) : _vm._e()], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": '/trial/new'
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-card-text', {
    staticClass: "cyanLight editDialogsRow"
  }, [_vm._v("\n          Add Trial\n          "), _c('v-icon', {
    staticClass: "text-xs-right"
  }, [_vm._v("add")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-514f34a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trials/Investigators/Singular.vue
// module id = 682
// module chunks = 1